import { Component, OnInit, Inject } from "@angular/core";
import { Pipe, PipeTransform } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { EmpInfo } from "../model/emp.model";
import { UserLoginInfo } from "../model/userlogin.model";
import { ProjectInfo } from "../model/project.model";
import { ProjectMemberInfo } from "../model/projectmember.model";
import { environment } from "src/environments/environment";

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { sha256, sha224 } from "js-sha256";
import { TokenService } from "../service/token.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-user-detail",
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.css"],
})
export class UserDetailComponent implements OnInit {
  form: FormGroup;
  titlemodal: string;
  detailmodal: string;
  baseurl: string;
  _ParamEmpCode: string;
  EmpList: EmpInfo[];
  UserloginList: UserLoginInfo[] = [];
  ProjectList: ProjectInfo[];
  ProjectMemberList: ProjectMemberInfo[];

  subscriptionLoadEmpList: Subscription;
  subscriptionLoadUserloginList: Subscription;
  subscriptionLoadProjectList: Subscription;
  subscriptionLoadProjectMemberList: Subscription;
  // Emp Detail Zone
  txtEmployeeCode: string;
  txtTitle: string;
  txtFirstName: string;
  txtLastName: string;
  txtPosition: string;
  txtTeam: string;
  txtRole: string;

  txtNew: string;
  flagduplicate: boolean;
  flagpasswordconfirm: boolean;

  hidUserLoginId: number;
  hidEmpCodeUpdatePermissionProject: string;
  hidUsernameUpdatePermissionProject: string;
  hidEmailUpdatePermissionProject: string;

  isOnUpdate: boolean;
  isSubmitted: any;
  arrayelement: any;
  isUserSubmitted: boolean = false;

  readonlyUseranme: string;
  readonlyEmail: string;

  thisemail: string;
  //Token
  getTokenUrl: string;

  constructor(
    private httpClient: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private TokenService: TokenService
  ) {
    this.baseurl = environment.base_api;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
    //Set param
    this.activatedRoute.params.subscribe((params) => {
      this._ParamEmpCode = params["EmpCode"];
    });
  }
  ngOnInit() {
    this.arrayelement = [];
    this.txtNew = "";
    this._ParamEmpCode = !!this._ParamEmpCode
      ? this._ParamEmpCode
      : localStorage.getItem("EmpCode");
    this.LoadEmpDetailList();
    this.LoadUserLoginList();

    this.form = this.formBuilder.group({
      //Username: [null, Validators.required],
      Email: [null],
      //Password: [null, Validators.required],
      //ConfirmPassword: [null, Validators.required],
      Password: [
        null,
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_])(?=.{8,})/
          ),
          Validators.minLength(8),
        ],
      ],
      ConfirmPassword: [
        null,
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\_])(?=.{8,})/
          ),
          Validators.minLength(8),
        ],
      ],
    });
  }

  async LoadEmpDetailList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.subscriptionLoadEmpList = this.LoadEmpDetail(auth_token).subscribe({
        next: (data) => {
          this.subscriptionLoadEmpList.unsubscribe();
          this.EmpList = data;
          if (this.EmpList.length) {
            this.txtEmployeeCode =
              this.EmpList[0].EmpCode != null ? this.EmpList[0].EmpCode : null;
            this.txtTitle =
              this.EmpList[0].Title_Name != null
                ? this.EmpList[0].Title_Name
                : "";
            this.txtFirstName =
              this.EmpList[0].EmpFname_TH != null
                ? this.EmpList[0].EmpFname_TH
                : null;
            this.txtLastName =
              this.EmpList[0].EmpLname_TH != null
                ? this.EmpList[0].EmpLname_TH
                : null;
            this.txtPosition =
              this.EmpList[0].PositionName != null
                ? this.EmpList[0].PositionName
                : null;
            this.txtTeam =
              this.EmpList[0].TeamName != null
                ? this.EmpList[0].TeamName
                : null;
            this.txtRole =
              this.EmpList[0].RoleName != null
                ? this.EmpList[0].RoleName
                : null;
            // this.form.controls["Email"].setValue(
            //   this.EmpList[0].Mail.toString() ?? ""
            // );
            //this.form.patchValue({Email: this.EmpList[0].Mail.toString() ?? ""});

            this.thisemail = this.EmpList[0].Mail.toString() ?? "";
            console.log("this.thisemail === ", this.thisemail);
          }
        },
        error: (error) => {
          console.error("There was an error!", error);
        },
      });
    }
  }

  LoadUserLoginList() {
    this.subscriptionLoadUserloginList = this.LoadUserLogin().subscribe({
      next: (data) => {
        this.subscriptionLoadUserloginList.unsubscribe();
        this.UserloginList = data;
      },
      error: (error) => {
        console.error("There was an error!", error);
      },
    });
  }

  LoadEmpDetail(auth_token): Observable<EmpInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth_token}`,
      }),
    };

    var objectjson = {};
    objectjson["EmpCode"] = this.checkUndefinedString(this._ParamEmpCode);
    let strjson = JSON.stringify(objectjson);

    return this.httpClient.post<EmpInfo[]>(
      this.baseurl + "Employee/GetEmployeeCriteria",
      strjson,
      httpOptions
    );
  }

  LoadUserLogin(): Observable<UserLoginInfo[]> {
    //var auth_token = this.TokenService.RefreshToken();
    //if (!!auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        //'Authorization': `Bearer ${auth_token}`
      }),
    };

    var objectjson = {};
    objectjson["EmpCode"] = this.checkUndefinedString(this._ParamEmpCode);
    let strjson = JSON.stringify(objectjson);

    return this.httpClient.post<UserLoginInfo[]>(
      this.baseurl + "UserLogin/getUserLogin",
      strjson,
      httpOptions
    );

    //}
  }

  LoadProject(auth_token): Observable<ProjectInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth_token}`,
      }),
    };

    var objectjson = {};
    objectjson["FlagDelete"] = "N";
    let strjson = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectInfo[]>(
      this.baseurl + "Project/GetProjectCriteria",
      strjson,
      httpOptions
    );
  }

  async LoadProjectList(EmpCode, Username, Email) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.subscriptionLoadProjectList = this.LoadProject(auth_token).subscribe(
        (data) => {
          this.subscriptionLoadProjectList.unsubscribe();
          this.ProjectList = data;

          // get project current username
          this.subscriptionLoadProjectMemberList = this.LoadProjectMember(
            EmpCode,
            Username,
            Email,
            auth_token
          ).subscribe(
            (data) => {
              this.subscriptionLoadProjectMemberList.unsubscribe();
              this.ProjectMemberList = data;
              $('[name="checkboxPermissionProject"]').prop("checked", false); // clear checkbox
              $('[name="CheckboxTicketFlag"]').prop("disabled", true); // clear checkbox support ticket to disabled

              this.ProjectMemberList.forEach((element) => {
                $(
                  '[name="checkboxPermissionProject"][value="' +
                    element.ProjectCode +
                    '"]'
                ).prop("checked", true);
                if (element.FlagSupportTicket == "Y") {
                  $(
                    '[name="CheckboxTicketFlag"][value="' +
                      element.ProjectCode +
                      '"]'
                  ).prop("checked", true);
                }
                $(
                  '[name="CheckboxTicketFlag"][value="' +
                    element.ProjectCode +
                    '"]'
                ).prop("disabled", false);
              });

              $("#ModalSetPermissionProject").modal();
            },
            (err) => {
              console.error("Observer got an error: " + err);
            },
            () => {
              console.log("Observer got a complete notification");
            }
          );
        },
        (err) => {
          console.error("Observer got an error: " + err);
        },
        () => {
          console.log("Observer got a complete notification");
        }
      );
    }
  }

  LoadProjectMember(
    EmpCode,
    Username,
    Email,
    auth_token
  ): Observable<ProjectMemberInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth_token}`,
      }),
    };

    var objectjson = {};
    objectjson["EmpCode"] = this.checkUndefinedString(EmpCode);
    objectjson["Username"] = this.checkUndefinedString(Username);
    objectjson["Email"] = this.checkUndefinedString(Email);

    let strjson = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectMemberInfo[]>(
      this.baseurl + "ProjectMember/GetProjectMember",
      strjson,
      httpOptions
    );
  }

  async btnClick_submitInsertUserLogin() {
    this.isUserSubmitted = true;
    if (
      this.form.valid &&
      this.flagduplicate == false &&
      this.flagpasswordconfirm == false
    ) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log("form submitted");
        this.OnCreatingUserLogin("y");
        const httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth_token}`,
          }),
        };

        var objectjson = {};
        /*      objectjson['Username'] = this.checkUndefinedString(this.form.controls['Username'].value);*/
        objectjson["Email"] = this.checkUndefinedString(
          // this.form.controls["Email"].value
          this.thisemail
        );
        console.log("TEST-" + this.thisemail)
        objectjson["Password"] = sha256(
          this.checkUndefinedString(this.form.controls["Password"].value)
        );
        objectjson["EmpCode"] = this.checkUndefinedString(this._ParamEmpCode);
        objectjson["CreateBy"] = this.checkUndefinedString(
          localStorage.getItem("EmpCode")
        );
        objectjson["FlagDelete"] = "N";

        if (objectjson["Email"] == "") {
          alert("Missing Email");
          return;
        }

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient
          .post<UserLoginInfo[]>(
            this.baseurl + "UserLogin/InsertUserLogin",
            strjson,
            httpOptions
          )

          .subscribe(
            (result) => (this.isSubmitted = result),
            (failCb) => {
              console.log("Insert fail");
              this.OnCreatingUserLogin("n");
            },
            () => {
              console.log("Insert = " + this.isSubmitted);
              this.OnCreatingUserLogin("n");

              $("#ModalCreateComplate").modal();
              this.LoadUserLoginList();
              window.location.reload();
            }
          );
      }
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  btnClick_onUpdateUserLogin(id) {
    //$('#Username').attr('disabled', 'disabled');
    //$('#Email').attr('disabled', 'disabled');
    this.isUserSubmitted = true;
    $("#ModalUserLogin").modal("hide");
    this.isOnUpdate = true;
    this.txtNew = "New";
    let index = this.UserloginList.findIndex((x) => x.Id == id);

    this.form.patchValue({
      Username:
        this.UserloginList[index].Username != null
          ? this.UserloginList[index].Username
          : null,
      Email:
        this.UserloginList[index].Mail != null
          ? this.UserloginList[index].Mail
          : null,
    });

    this.hidUserLoginId = this.UserloginList[index].Id;

    $("#ModalUserLogin").modal();
  }

  async btnClick_submitUpdateUserLogin(id) {
    if (this.form.valid && this.flagpasswordconfirm == false) {
      this.OnUpdatingUserLogin("y");

      id = this.hidUserLoginId;
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth_token}`,
          }),
        };

        var objectjson = {};
        objectjson["Id"] = id;
        objectjson["Password"] = sha256(
          this.checkUndefinedString(this.form.controls["Password"].value)
        );
        objectjson["Email"] = this.checkUndefinedString(
          this.form.controls["Email"].value
        );
        objectjson["UpdateBy"] = this.checkUndefinedString(
          localStorage.getItem("EmpCode")
        );

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient
          .post<UserLoginInfo[]>(
            this.baseurl + "UserLogin/UpdateUserLogin",
            strjson,
            httpOptions
          )

          .subscribe(
            (result) => (this.isSubmitted = result),
            (failCb) => {
              console.log("Update fail");
              this.OnUpdatingUserLogin("n");
            },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdatingUserLogin("n");
              $("#ModalUpdateComplate").modal();

              this.LoadUserLoginList();
            }
          );
      }
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  btnClick_deleteUserLogin(id, auth_token): Observable<UserLoginInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth_token}`,
      }),
    };
    var objectjson = {};
    objectjson["Id"] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<UserLoginInfo[]>(
      this.baseurl + "UserLogin/DeleteUserLogin",
      strjsonCusInfo,
      httpOptions
    );
  }

  btnClick_onSetPermissionProject(
    Empcode: string,
    Username: string,
    Email: string
  ) {
    //if (this.txtRole == 'Manager') {
    //  this.titlemodal = '';
    //  this.detailmodal = 'You are in Role Manager, can see every project and don\'t need any setting.';
    //  $('#ModalComplate').modal();
    //  $('#ModalComplate .modal-header').addClass('bg-gold');
    //  $('#ModalComplate .modal-header').text("Information");

    //} else {
    this.readonlyUseranme = Username;
    this.readonlyEmail = Email;
    this.hidEmpCodeUpdatePermissionProject = Empcode;
    this.hidUsernameUpdatePermissionProject = Username;
    this.hidEmailUpdatePermissionProject = Email;
    this.LoadProjectList(Empcode, Username, Email);
    // }
  }

  async btnClick_submitUpdatPermissionProject() {
    $("#btnsubmitUpdatePermissionProject").hide();
    $("#loadingupdate").show();
    var EmpCode = this.hidEmpCodeUpdatePermissionProject;
    var Username = this.hidUsernameUpdatePermissionProject;
    var Email = this.hidEmailUpdatePermissionProject;
    let observableBatch = [];
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth_token}`,
        }),
      };
      this.arrayelement = $(
        '[name="checkboxPermissionProject"]:checked'
      ).clone();

      // Delete Project Member old
      this.ProjectMemberList.forEach((element) => {
        var objectjson = {};
        objectjson["Id"] = element.Id;
        var strjson = JSON.stringify(objectjson);

        observableBatch.push(
          this.httpClient
            .post<ProjectMemberInfo[]>(
              this.baseurl + "ProjectMember/DeleteProjectMember",
              strjson,
              httpOptions
            )
            .toPromise()
        );
      });
      // Insert New Member
      for (let i = 0; i < this.arrayelement.length; i++) {
        var objectjson = {};
        objectjson["EmpCode"] = EmpCode;
        objectjson["Username"] = Username;
        objectjson["ProjectCode"] = this.arrayelement[i].value;
        var flagticket = $(
          '[name="CheckboxTicketFlag"][value="' +
            this.arrayelement[i].value +
            '"]'
        ).prop("checked");

        objectjson["FlagSupportTicket"] = flagticket == true ? "Y" : "N";

        var strjson = JSON.stringify(objectjson);

        observableBatch.push(
          this.httpClient
            .post<ProjectMemberInfo[]>(
              this.baseurl + "ProjectMember/InsertProjectMember",
              strjson,
              httpOptions
            )
            .toPromise()
        );
      }

      Promise.all(observableBatch).then((val) => {
        $("#ModalSetPermissionProject").modal("hide");
        $("#btnsubmitUpdatePermissionProject").show();
        $("#loadingupdate").hide();
        console.log("สำเร็จ");
        $("#ModalUpdatePermissionProjectComplate").modal("show");
        this.LoadUserLogin();
      });
    }
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxUserLogin"]').prop("checked", check);
  }

  chkallclickpermission(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxPermissionProject"]').prop("checked", check);
    $('[name="CheckboxTicketFlag"]').prop("checked", check);

    if (check == true) {
      $('[name="CheckboxTicketFlag"]').prop("disabled", false);
    } else {
      $('[name="CheckboxTicketFlag"]').prop("disabled", true);
    }
  }

  chkprojectclickpermission(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $(
      '[name="CheckboxTicketFlag"][value="' + traget.currentTarget.value + '"]'
    ).prop("checked", check);

    if (check == true) {
      $(
        '[name="CheckboxTicketFlag"][value="' +
          traget.currentTarget.value +
          '"]'
      ).prop("disabled", false);
    } else {
      $(
        '[name="CheckboxTicketFlag"][value="' +
          traget.currentTarget.value +
          '"]'
      ).prop("disabled", true);
    }
  }

  async btnClick_deleteUserLoginitem(id) {
    if (confirm("Are you sure you want to delete this User Login ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteUserLogin(parseInt(id), auth_token)
          .toPromise()
          .then((data) => {
            console.log("หลังรับค่า");
            $("#ModalDeleteComplate").modal("show");
            this.LoadUserLoginList();
          });
      }
    }
  }

  async btnClick_onDeleteUserloginList() {
    if (confirm("Are you sure you want to delete this User Login?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedUserLogin = $('[name="checkboxUserLogin"]:checked');

        let num = checkkedUserLogin.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {
          var UserLogincurrent = <HTMLInputElement>checkkedUserLogin[i];
          observableBatch.push(
            this.btnClick_deleteUserLogin(
              parseInt(UserLogincurrent.value),
              auth_token
            )
              .toPromise()
              .then((val) => {})
          );
        }

        Promise.all(observableBatch).then((val) => {
          console.log("สำเร็จ");
          $("#ModalDeleteComplate").modal("show");
          this.LoadUserLogin();
        });
      }
    }
  }

  btnClick_onCreateUserLogin() {
    // console.log("btnClick_onCreateUserLogin = ", this.thisemail);
    let mail = this.thisemail;
    this.form.reset();
    $("#UserLoginCode").removeAttr("disabled");
    $("#ModalUserLogin").modal("show");
    this.ClearinputUserLogin();
    this.thisemail = mail;
    this.isOnUpdate = false;
  }

  ClearinputUserLogin() {
    this.form.patchValue({
      Username: "",
      Email: "",
      Password: "",
      ConfirmPassword: "",
    });
  }

  OnCreatingUserLogin(flag) {
    if (flag == "y") {
      $("#loadingcreate").show();
      $("#btnsubmitUserLogin").hide();
      $("#btncloseicon").prop("disabled", true);
      $("#btnclose").prop("disabled", true);
    } else if (flag == "n") {
      $("#loadingcreate").hide();
      $("#btnsubmitUserLogin").show();
      $("#btncloseicon").removeAttr("disabled");
      $("#btnclose").removeAttr("disabled");
      $("#ModalUserLogin").modal("hide");
    }
  }

  OnUpdatingUserLogin(flag) {
    if (flag == "y") {
      $("#loadingupdate").show();
      $("#btnsubmitUserLogin").hide();
      $("#btncloseicon").prop("disabled", true);
      $("#btnclose").prop("disabled", true);
    } else if (flag == "n") {
      $("#loadingupdate").hide();
      $("#btnsubmitUserLogin").show();
      $("#btncloseicon").removeAttr("disabled");
      $("#btnclose").removeAttr("disabled");
      $("#ModalUserLogin").modal("hide");
    }
  }

  CheckduplicateUserLogin() {
    if (this.isOnUpdate == true) {
      return false;
    }

    //var Username = this.form.controls['Username'].value;
    //let index = !!this.UserloginList ? this.UserloginList.findIndex(x => x.Username == Username) : -1;
    var Email = this.thisemail;//this.form.controls["Email"].value;
    let index = !!this.UserloginList
      ? this.UserloginList.findIndex((x) => x.Mail == Email)
      : -1;
    var flagreturn = false;
    if (index != -1) {
      flagreturn = true;
    }
    this.flagduplicate = flagreturn;
    return flagreturn;
  }

  CheckConfirmPassword() {
    var password = this.form.controls["Password"].value;
    var confirmpassword = this.form.controls["ConfirmPassword"].value;
    if (password != confirmpassword) {
      this.flagpasswordconfirm = true;
    } else {
      this.flagpasswordconfirm = false;
    }

    return this.flagpasswordconfirm;
  }

  isFieldValid(field: string) {
    return (
      this.isUserSubmitted &&
      !this.form.get(field).valid &&
      this.form.get(field).touched
    );
  }

  displayFieldCss(field: string) {
    return {
      "has-error": this.isFieldValid(field),
      "has-feedback": this.isFieldValid(field),
    };
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = "";
    }
    return strInput;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  GetParam(name) {
    const results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
      window.location.href
    );
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  ConvertDate(DateValue) {
    if (DateValue) {
      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = "";

      if (day < 10) {
        daystr = "0" + day;
      } else {
        daystr = day.toString();
      }

      var monthIndex = date.getMonth() + 1;
      var monthstr = "";

      if (monthIndex < 10) {
        monthstr = "0" + monthIndex;
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Hoursstr = "";
      var Minutesstr = "";

      if (Hours < 10) {
        Hoursstr = "0" + Hours;
      } else {
        Hoursstr = Hours.toString();
      }
      if (Minutes < 10) {
        Minutesstr = "0" + Minutes;
      } else {
        Minutesstr = Minutes.toString();
      }
      var Datenow = "";

      Datenow =
        monthstr +
        "/" +
        daystr +
        "/" +
        year +
        " " +
        Hoursstr +
        ":" +
        Minutesstr;
    } else {
      Datenow = null;
    }

    return Datenow;
  }

  //OAuth 2
  AuthorizeUser(txtEmpCode) {
    //Open new tab to do OAuth2
    this.getTokenUrl = this.TokenService.GetAccessTokenUrl(txtEmpCode);
    window.open(this.getTokenUrl, "_blank");
  }
}
